import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=e21dc498&scoped=true&"
import script from "./trainDetail.vue?vue&type=script&lang=js&"
export * from "./trainDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainDetail.vue?vue&type=style&index=0&id=e21dc498&prod&scoped=true&lang=scss&"
import style1 from "./trainDetail.vue?vue&type=style&index=1&id=e21dc498&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dc498",
  null
  
)

export default component.exports